<template>
    <div class="form-header-buttons--group">
        <a class="form-header-buttons--back btn btn-light-grey" :href="backUrl" v-if="backUrl != null">Back</a>

        <a class="form-header-buttons--save btn btn-primary" href="#" @click="save">Save</a>
    </div>
</template>

<script>
	export default {
        name: "FormHeaderButtons",
        
        props: {
            backUrl: {
                type: String,
                default: null
            }
		},

        methods: {
            save: function(e){
                e.preventDefault();

                return;
            }
        },
	}
</script>
